interface DiscountableVariant {
  price: number;
  discountPrice?: number | null;
  discountEndsAt?: string | Date | null;
}

export function getEffectivePrice(variant: DiscountableVariant | null | undefined) {
  if (!variant) {
    return { hasDiscount: false, effectivePrice: 0, discountPercent: 0, daysLeft: null as number | null };
  }

  const notExpired = !variant.discountEndsAt || new Date(variant.discountEndsAt) > new Date();
  const hasDiscount =
    variant.discountPrice != null &&
    variant.discountPrice > 0 &&
    variant.discountPrice < variant.price &&
    notExpired;

  const discountPercent = hasDiscount
    ? Math.round((1 - variant.discountPrice! / variant.price) * 100)
    : 0;

  const daysLeft =
    hasDiscount && variant.discountEndsAt
      ? Math.max(0, Math.ceil((new Date(variant.discountEndsAt).getTime() - Date.now()) / 86400000))
      : null;

  return {
    hasDiscount,
    effectivePrice: hasDiscount ? variant.discountPrice! : variant.price,
    discountPercent,
    daysLeft,
  };
}
